import { Injectable } from '@angular/core';

export interface SavedCredentials {
  email: string;
  password: string;
}

/**
 * Web no-op. The browser's built-in password manager and the HTML
 * `autocomplete="username" / "current-password"` attributes on the login form
 * handle credential persistence natively — we don't add our own prompt on top.
 *
 * The native override (`credential-prompt.service.native.ts`) stores email +
 * password via `capacitor-secure-storage-plugin`, which wraps the iOS Keychain
 * and Android Keystore-backed EncryptedSharedPreferences. Storage is
 * per-app (not iCloud/Google-synced), encrypted at rest, and inaccessible
 * while the device is locked.
 */
@Injectable({ providedIn: 'root' })
export class CredentialPromptService {

  /** Returns the previously-saved credentials for this user, if any. */
  async getSavedCredentials(): Promise<SavedCredentials | null> {
    return null;
  }

  /**
   * Called after a successful login. On native, offers to save the credentials
   * for next time if they aren't already saved. On web this is a no-op — the
   * browser password manager owns this flow.
   */
  async promptToSaveIfUnsaved(_email: string, _password: string): Promise<void> {
    // no-op on web
  }

  /** Clear any saved credentials. Called on logout. */
  async clearSavedCredentials(): Promise<void> {
    // no-op on web
  }
}
